var map = {
	"./rabbit 06.jpg": 48381,
	"./rabbit 4.jpg": 50407,
	"./rocket.jpg": 7083,
	"./school boy .jpg": 38353,
	"./vegitables.jpg": 22279,
	"./zirafee.jpg": 74439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30405;